import {IMenuItemDTO} from '@/TPWebClientInternal/dtos/menu-item.dto';
import {IMenuOption} from '@/store/modules/menu.store';
import {find} from 'lodash';


export interface ISlimItem {
	price: number;
}

export interface ISlimOption {
	optionId: string;
	freeChoicesCount: number;
	choices: ISlimChoice[];
	price: number;
}

export interface ISlimChoice {
	choiceId: string;
	price: number;
}

export interface ISlimSelectedOption {
	optionId: string;
	choices: ISlimSelectedChoice[];
}

export interface ISlimSelectedChoice {
	choiceId: string;
	quantity: number;
}

export default class TPWebClientInternalHelpers {

	static calculatePrice(item: ISlimItem, options: ISlimOption[], selectedOptions: ISlimSelectedOption[]) {
		let price = item.price;
		selectedOptions.forEach((selectedOption) => {
			let choiceCosts: number[] = [];
			const option = find(options, {optionId: selectedOption.optionId});
			if(!option) {
				throw new Error('Selected option not found in options');
			}
			selectedOption.choices.forEach((selectedChoice) => {
				const choice = find(option.choices, {choiceId: selectedChoice.choiceId});
				if(!choice) {
					throw new Error('Selected choice not found in choices');
				}
				choiceCosts.push(option.price + choice.price);
			});
			choiceCosts = choiceCosts.sort().reverse();
			if(option.freeChoicesCount > 0) {
				choiceCosts.splice(0, Math.min(option.freeChoicesCount, choiceCosts.length));
			}
			price += choiceCosts.reduce((total, choiceCost) => {
				total += choiceCost;
				return total;
			}, 0);
		});

		return price;
	}

}
